const CarouselHero = {
  resizeTimeout: null,
  previousWindowInnerWidth: window.innerWidth,
  SELECTORS: {
    container: '[data-js-carousel-hero]',
  },
  init() {
    const containerElements = document.querySelectorAll(this.SELECTORS.container);

    containerElements.forEach((containerElement) => {
      new Swiper(containerElement, {
        loop: true,
        slidesPerView: 'auto',
        loopAdditionalSlides: 1,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400,
        watchOverflow: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1440: {
            spaceBetween: 160,
          },
        },
      });
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  CarouselHero.init();
});

document.addEventListener('shopify:section:load', () => {
  CarouselHero.init();
});

document.addEventListener('shopify:section:reorder', () => {
  CarouselHero.init();
});

function reinitializeCarouselHeroOnWindowResize() {
  if (window.innerWidth === CarouselHero.previousWindowInnerWidth) {
    return;
  }

  CarouselHero.previousWindowInnerWidth = window.innerWidth;

  clearTimeout(CarouselHero.resizeTimeout);

  CarouselHero.resizeTimeout = setTimeout(() => {
    CarouselHero.init();
  }, 1000);
}

window.addEventListener('resize', () => {
  reinitializeCarouselHeroOnWindowResize();
});
